import { createRoot } from 'react-dom/client'

import App from './App'

import './fonts/NotoSans-Regular.ttf'

import * as Sentry from '@sentry/react'

import './index.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_URL,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 0.2,
  debug: false,
  replaysOnErrorSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  profilesSampleRate: 0.1,
  ignoreErrors: [
    /Error: Failed to load Stripe\.js/,
    /Error: Java object is gone/,
    /Error: Java exception was raised during method invocation/,
    /AbortError: The play\(\) request was interrupted/,
    /InvalidAccessError: Page already has an active payment session/,
    /InvalidAccessError: The object does not support the operation or argument/,
    /TypeError: null is not an object \(evaluating 'document\.querySelector\('video'\)\.pause'\)/,
    /TypeError: Cannot read (properties|property) of null \(reading 'target'\)/,
    /UnknownError: Object captured as promise rejection with keys/,
  ],
})

const domNode = document.getElementById('root')
const root = createRoot(domNode)
root.render(<App />)
